
const data = {
    checkbox: 'You may select one or more answers',
    radio: 'Please select one answer',
}
class WatuPro {
    constructor () {
        this.forms = document.querySelectorAll('.quiz-form')
        
        if (this.forms.length) {
            this.forms.forEach(this.init, this)
        }
    }

    init (el) {
        const questions = el.querySelectorAll('.watu-question')
        if (questions.length) {
            questions.forEach(this.processQuestion, this)
        }
    }

    processQuestion (el) {
        for (const type in data) {
            const input = el.querySelector('[type=' + type + ']')
            if (input) {
                const title = el.querySelector('.question-content')
                if (title) {
                    const message = document.createElement('span')
                    message.classList.add('question-content__info')
                    message.innerHTML = data[type]
                    title.append(message)
                    break
                }
            }
        }
    }
}

export default WatuPro